import { apiClient } from './client';
import { CompanyGateLog, CompanyGateLogPayload, GateLogType } from '../types/gateLog';
import { DEFAULT_PAGE_SIZE, PageResponse } from '../types/page';

export async function fetchGateLogs(params?: {
  type?: GateLogType | 'ALL' | string;
  keyword?: string;
  page?: number;
  size?: number;
}): Promise<PageResponse<CompanyGateLog>> {
  const { data } = await apiClient.get<PageResponse<CompanyGateLog>>('/gate-logs', {
    params: {
      ...(params?.type && params.type !== 'ALL' ? { type: params.type } : {}),
      ...(params?.keyword?.trim() ? { q: params.keyword.trim() } : {}),
      page: params?.page ?? 0,
      size: params?.size ?? DEFAULT_PAGE_SIZE,
    },
  });
  return data;
}

export async function fetchGateLogCalendar(from: string, to: string): Promise<CompanyGateLog[]> {
  const { data } = await apiClient.get<CompanyGateLog[]>('/gate-logs/calendar', {
    params: { from, to },
  });
  return data;
}

export async function fetchGateLog(logId: number): Promise<CompanyGateLog> {
  const { data } = await apiClient.get<CompanyGateLog>(`/gate-logs/${logId}`);
  return data;
}

export async function createGateLog(payload: CompanyGateLogPayload): Promise<CompanyGateLog> {
  const { data } = await apiClient.post<CompanyGateLog>('/gate-logs', payload);
  return data;
}

export async function updateGateLog(
  logId: number,
  payload: CompanyGateLogPayload
): Promise<CompanyGateLog> {
  const { data } = await apiClient.patch<CompanyGateLog>(`/gate-logs/${logId}`, payload);
  return data;
}

export async function deleteGateLog(logId: number): Promise<void> {
  await apiClient.delete(`/gate-logs/${logId}`);
}
